<template>
  <div class="container page" style="background: #1f1c1f;">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{$t("setting.fill_bank_tip")}}</div>
      <van-cell-group>
        <!-- 虚拟货币钱包地址（原银行账号字段） -->
        <van-field v-model="walletAddress" :label="$t('setting.band_account')"  :placeholder="$t('setting.band_account_tip')" :readonly="isBound"/>
        <!-- 账户名（保持不变） -->
        <van-field v-model="username" :label="$t('setting.username')" :placeholder="$t('setting.username_place')" :readonly="isBound"/>
      </van-cell-group>
      <p>{{$t("setting.bank_warn")}}</p>
    </div>
    <div class="sub-btn" @click="bindWallet()">
      {{$t("setting.bank_ok")}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      walletAddress: "",      // 原 bankid 字段，现用于钱包地址
      username: "",
      isBound: false,  // 新增：是否已绑定钱包
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindWallet() {
      // 校验是否已绑定
      if (this.isBound) {
    this.$toast(this.$t("setting.bindinged"));
    return;
  }
      if (this.walletAddress === "") {
        this.$toast.fail(this.$t("setting.qsrdz"));
        return false;
      }
      if (this.username === "") {
        this.$toast(this.$t("setting.username_place"));
        return false;
      }

      this.$http({
        method: 'post',
        data: {
          walletAddress: this.walletAddress,   // 提交钱包地址
          username: this.username,
        },
        url: 'user_set_bank'    // 接口路径可保持不变，后端需适配
      }).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: '/Mine' });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.username = res.data.name;
          // 如果 userInfo 中包含钱包地址，可回显
          if (res.data.walletAddress) {
            this.walletAddress = res.data.walletAddress;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      // 原获取银行卡信息接口，若后端已改为钱包地址，可保留；否则可移除
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          // 后端返回的字段为 is_bank
      this.isBound = res.data.is_bank;  // 关键：绑定状态
          if (res.data.is_bank) {
            // 假设后端返回字段为 walletAddress 和 username
            this.walletAddress = res.data.info.walletAddress;
            this.username = res.data.info.username;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();   // 如果后端接口不变，此方法可能失效，建议根据实际情况调整或移除
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);
  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
/deep/ .van-field__label{
  color: #ccc;
}
.van-cell-group{
  background-color: transparent;
  padding: 30px 0;
  &:after{
    display: none;
  }
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  margin-bottom: 20px;
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}
.main-box .label{
  padding: 20px 0 20px 26px;
  font-size: 35px;
  color: #f3c7a2;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #f3c7a2;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg,#e6c3a1,#7e5678);
}
</style>